export const namespaced = true;

import VideoViewingService from '@/services/VideoViewingService.js';
import SchoolService from '@/services/SchoolService.js';
import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';

export const state = {
  videoViewings: [],
  videoViewing: {},
  editingVideoViewing: null,
};

export const mutations = {
  SET_VIDEO_VIEWINGS(state, videoViewings) {
    state.videoViewings = videoViewings;
  },
  SET_VIDEO_VIEWING(state, videoViewing) {
    state.videoViewing = videoViewing;
  },
  SET_EDITING_VIDEO_VIEWING(state, videoViewing) {
    state.editingVideoViewing = videoViewing;
  },
  DELETE_EDITING_VIDEO_VIEWING(state) {
    state.editingVideoViewing = null;
  },
  ADD_VIDEO_VIEWING(state, videoViewing) {
    state.videoViewing = videoViewing;
  },
  DELETE_VIDEO_VIEWING() {
    // We only delete Video Viewing, so we don't need to do anything here
  },
};

export const actions = {
  fetchVideoViewings({ commit }, schoolId) {
    return SchoolService.videoViewings(schoolId).then((response) => {
      commit('SET_VIDEO_VIEWINGS', response.data);
    });
  },
  setVideoViewing({ commit }, videoViewing) {
    commit('SET_VIDEO_VIEWING', videoViewing);
  },
  startEditingVideoViewing({ commit }, videoViewing) {
    commit('SET_EDITING_VIDEO_VIEWING', videoViewing);
  },
  finishEditingVideoViewing({ commit, state }) {
    if (state.editingVideoViewing) {
      let formattedVideoViewing = cloneDeep(state.editingVideoViewing);
      if (formattedVideoViewing.corporation) {
        formattedVideoViewing.corporationId = formattedVideoViewing.corporation.id;
        formattedVideoViewing = omit(formattedVideoViewing, ['corporation']);
      }
      if (formattedVideoViewing.brand) {
        formattedVideoViewing.brandId = formattedVideoViewing.brand.id;
        formattedVideoViewing = omit(formattedVideoViewing, ['brand']);
      }
      if (formattedVideoViewing.school) {
        formattedVideoViewing.schoolId = formattedVideoViewing.school.id;
        formattedVideoViewing = omit(formattedVideoViewing, ['school']);
      }
      if (formattedVideoViewing.course) {
        formattedVideoViewing.courseId = formattedVideoViewing.course.id;
        formattedVideoViewing = omit(formattedVideoViewing, ['course']);
      }
      if (formattedVideoViewing.tamaiClass) {
        formattedVideoViewing.tamaiClassId = formattedVideoViewing.tamaiClass.id;
        formattedVideoViewing = omit(formattedVideoViewing, ['tamaiClass']);
      }
      if (formattedVideoViewing.figuredProduct) {
        formattedVideoViewing.productCode = formattedVideoViewing.figuredProduct;
        formattedVideoViewing = omit(formattedVideoViewing, ['figuredProduct']);
      }
      formattedVideoViewing = omit(formattedVideoViewing, ['videoPoles']);

      return VideoViewingService.create(formattedVideoViewing).then((response) => {
        commit('DELETE_EDITING_VIDEO_VIEWING');
        commit('ADD_VIDEO_VIEWING', response.data);
      });
    }
  },
  clearEditingVideoViewing({ commit, state }) {
    if (state.editingVideoViewing) {
      commit('DELETE_EDITING_VIDEO_VIEWING');
    }
  },
  addVideoViewing({ commit }, videoViewing) {
    commit('ADD_VIDEO_VIEWING', videoViewing);
  },
  deleteVideoViewing({ commit }, id) {
    return VideoViewingService.delete(id).then(() => {
      commit('DELETE_VIDEO_VIEWING');
    });
  },
};

export const getters = {
  getVideoViewingById: (state) => (id) => {
    return state.videoViewings.find((item) => item.id == id);
  },
  getVideoViewingPoleById: (state) => (payload) => {
    const videoViewing = state.videoViewings.find((item) => item.id == payload.id);
    return videoViewing.videoPoles.find((poleItem) => poleItem.id == payload.poleId);
  },
  totalVideoViewings: (state) => {
    return state.videoViewings.length;
  },
  existsRegistrationRequiredParams: (state) => {
    if (!state.editingVideoViewing.figuredProduct) return false;
    if (!state.editingVideoViewing.nameReading) return false;
    if (!state.editingVideoViewing.uid) return false;

    return true;
  },
};
